var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"A2627FB2-8536-4397-BFA8-5682E59A5FFE"),React.createElement("g",{"id":"propuesta-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":1},React.createElement("g",{"id":"home","transform":"translate(-1055.000000, -563.000000)","stroke":"#E85633","strokeWidth":"2"},React.createElement("g",{"id":"HEROBANNER","transform":"translate(0.000000, 64.000000)"},React.createElement("g",{"id":"link","transform":"translate(957.000000, 501.000000)"},React.createElement("g",{"id":"Group","transform":"translate(0.000000, -0.000000)"},React.createElement("polyline",{"id":"Line","points":"99 5.10594623 124 5.10594623 117.5 0"}))))))]);
}

Arrow.defaultProps = {"width":"29px","height":"9px","viewBox":"0 0 29 9","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
